import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

const TermsAndConditions: React.FC = () => {
  return (
    <PolicyLayout title="Terms and Conditions" image="/images/fhome-ingredients-rustic.jpg">
      <p>
        This document is an electronic record in terms of the Information Technology Act, 2000.
        By accessing or using https://fhome.shop/ and related services, you agree to these terms.
      </p>

      <h3>Platform Owner</h3>
      <p>
        Avinya Food Products, proprietor Geetha Kasiram, Plot No 5, Tiruvalluvar Street, Tirukoilur, Kallakurichi - 605757.
      </p>

      <h3>User Obligations</h3>
      <ul>
        <li>Provide accurate information during registration and use of services.</li>
        <li>Do not use the platform for unlawful or prohibited activities.</li>
        <li>Pay applicable charges associated with availing services.</li>
        <li>Do not misuse website content, design, or intellectual property.</li>
      </ul>

      <h3>Liability and Third-Party Links</h3>
      <p>
        Information and materials are provided as-is. FHome is not responsible for third-party
        websites linked from the platform. Users are responsible for reviewing third-party terms.
      </p>

      <h3>Governing Law</h3>
      <p>
        These terms are governed by the laws of India. Disputes are subject to applicable courts in India.
      </p>

      <h3>Updates</h3>
      <p>
        Terms may be updated periodically. Continued use of the platform indicates acceptance of updates.
      </p>
    </PolicyLayout>
  );
};

export default TermsAndConditions;
